import React, { FC } from 'react';
import i18n from '@yandex-int/i18n';
import Person from '@gravity-ui/icons/Person';
import Persons from '@gravity-ui/icons/Persons';
import Shield from '@gravity-ui/icons/Shield';
import * as keyset from 'i18n/Header';
import * as indexPageKeyset from 'i18n/SkillsIndex';
import * as settingsKeyset from 'i18n/SettingsLabels';
import { SkillAccess } from 'client/model/settings';
import { Channel, InstallableApp } from 'client/model/skill';
import { mapChannelToInstallableAppCard } from '../icons/InstallableAppIcons';

import styles from './DescribeAppInIcons.module.scss';

const t = i18n(keyset);
const tIndexPage = i18n(indexPageKeyset);
const tSettings = i18n(settingsKeyset);

const mapChannelToLabel: Record<Exclude<Channel, Channel.Thereminvox>, string> = {
    [Channel.AutoApp]: tIndexPage('auto-app'),
    [Channel.TvApp]: tIndexPage('tv'),
    [Channel.SmartScreenApp]: tIndexPage('smart-screen'),
    [Channel.AliceSkill]: '',
    [Channel.SmartHome]: '',
};

const ChannelLabel: FC<{ channel: Channel }> = ({ channel }) => {
    if (channel === Channel.Thereminvox) return null;
    const channelLabel = mapChannelToLabel[channel];
    if (!channelLabel) return null;
    return <span className={styles.blockElement}>{channelLabel}</span>;
};

export const DescribeAppInIcons: FC<{ installableApp: InstallableApp }> = ({ installableApp }) => {
    const displayPrivate = installableApp.onAir
        ? installableApp.skillAccess === SkillAccess.Private
        : installableApp?.draft?.skillAccess === SkillAccess.Private;
    const accessTypeLabel = String(displayPrivate ? tSettings('private') : tSettings('public')).toLowerCase();
    return (
        <div className={styles.describeAppInIconsContainer}>
            {mapChannelToInstallableAppCard?.[installableApp?.channel]?.icon}
            <ChannelLabel channel={installableApp?.channel} />
            {' • '}
            {displayPrivate ? <Person /> : <Persons />}
            <span className={styles.blockElement}>{accessTypeLabel}</span>
            {__appConfig.user.isAdmin && (
                <>
                    {' • '}
                    <div className={styles.adminBlock}>
                        <Shield />
                        <span className={styles.adminLabel}>{t('admin')}</span>
                    </div>
                </>
            )}
        </div>
    );
};
